// https://coolors.co/f7ade2-e59de7-d28ceb-b389ef-9385f2-859ef5-76b7f7-9ad1e9
// export const YELLOW = '#F7ADE2';
// export const RED = '#E59DE7';
// export const TEAL = '#D28CEB';
// export const LIGHTBLUE = '#B389EF';
// export const DARKBLUE = '#9385F2';
// export const COLOR6 = '#859EF5';
// export const COLOR7 = '#76B7F7';
// export const COLOR8 = '#9AD1E9';

// https://coolors.co/edae49-df7d53-d1495b-40a083-00798c-30638e-333684-331b5f
// export const YELLOW = '#EDAE49';
// export const RED = '#DF7D53';
// export const TEAL = '#D1495B';
// export const LIGHTBLUE = '#40A083';
// export const DARKBLUE = '#00798C';
// export const COLOR6 = '#30638E';
// export const COLOR7 = '#333684';
// export const COLOR8 = '#331B5F';

// https://coolors.co/d74a5d-e57e56-f0b04f-3ba584-038296-306a99-333592-3a1c6e
export const YELLOW = '#D74A5D';
export const RED = '#E57E56';
export const TEAL = '#F0B04F';
export const LIGHTBLUE = '#3BA584';
export const DARKBLUE = '#038296';
export const COLOR6 = '#306A99';
export const COLOR7 = '#333592';
export const COLOR8 = '#3A1C6E';